export async function fetchGallery() {
  const res = await fetch('/api/gallery');
  if (!res.ok) {
    throw new Error(`Gallery request failed (${res.status})`);
  }
  return res.json();
}
